<p style="font-weight: bold;text-align: center;font-size: 300px">404</p>
<p style="font-weight: bold;text-align: center;font-size: 50px">{{'errors.pageNotFound' | translate}}</p>
